import axios from "axios";
import store from "@/store";
export default function useRequest() {
  const request = (dataObj) => {
    const service = axios.create({
      baseURL: store.state.baseUrl + "/troubleshooting",
      timeout: 30000,
    });
    service.interceptors.request.use((config) => {
      return config;
    });
    service.interceptors.response.use(
      (response) => {
        const res = response.data;
        if (res.code === 200) {
          return res.data;
        } else {
          return Promise.reject(res.data.message);
        }
      },
      async (error) => {
        return Promise.reject(error);
      }
    );
    return service(dataObj);
  };
  return request;
}
